import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=2fac0b50&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=ts&"
export * from "./UserList.vue?vue&type=script&lang=ts&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=2fac0b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac0b50",
  null
  
)

component.options.__file = "UserList.vue"
export default component.exports